import { ProductInfo } from './types';
import { ImageContainer, Image } from './styles';

interface PrinterImageProps {
  printer: ProductInfo;
}

const PrinterImage: React.FC<PrinterImageProps> = ({ printer }) => (
  <ImageContainer>
    <Image src={printer.image.imgSrc} alt={printer.image.name} />
  </ImageContainer>
);

export default PrinterImage;
